export type TColorVariant = "primary" | "error" | "warning" | "success" | "tertiary";
export type TSizeVariant = "xs" | "sm" | "md" | "lg" | "xl";
